<template>
  <div class="overall-bg">
    <b-container>
      <b-row>
        <b-col>
          <BackToMasters :goback="$router.back"></BackToMasters>

          <Headerlayout :headertext="warningmsgcontent.TitleContent"></Headerlayout>
        </b-col>
      </b-row>
    </b-container>
  </div>

  <div class="overall-bg">
    <b-container>
      <div class="form-white-bg">
        <b-row>
          <b-row>
            <!-- <b-col lg="3" md="4" sm="6">
    
                  <div class="field">
    
                    <label>PR Code</label>
    
    
    
                    <p>{{ ObjVal.DocNo }}</p>
    
                  </div>
    
                </b-col>
    
    
    
                <b-col lg="3" md="4" sm="6" v-if="param == 'Hidden'">
    
                  <div class="field">
    
                    <label>PO Code</label>
    
    
    
                    <p>{{ ObjPOVal.DocNo }}</p>
    
                  </div>
    
                </b-col> -->

            <b-row>
              <b-col lg="2" class="field py-4">
                <label class="mb-0">{{ $t("PurchaseRequest.Code") }}</label>

                <p class="">{{ ObjVal.DocNo }}</p>
              </b-col>

              <b-col lg="2" class="field py-4">
                <label class="mb-0">{{ $t("PurchaseRequest.Date") }}</label>

                <p class="">{{ ObjPRInfo.DocDate }}</p>
              </b-col>

              <b-col lg="2" class="field py-4">
                <label class="mb-0">{{
                  $t("PurchaseRequest.RequestedBy")
                }}</label>

                <p class="">{{ ObjPRInfo.CreatedByName }}</p>
              </b-col>
            </b-row>
          </b-row>

          <b-row>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <!-- {{StoreID}} -->

                <!-- {{ StoreDropdown.StoreId }}
    
                     {{ StoreDropdown.StoreBrMapId }} -->

                <StoreDropDown :label="$t('PO.POCreation.store')" name="Store" id="Store"
                  v-model="StoreDropdown.StoreBrMapId" :storetype="0" :filterId="StoreID"
                  @update:modelValue="StoreOnChange" :rules="{ required: true }" :required-icon="true"
                  :disabled="StoreDropdownDisable" />
              </div>
            </b-col>

            <b-col lg="3" md="4" sm="6" v-if="param == 'PR'">
              <div class="nolabel">
                <div class="field" v-if="requestdropdown">
                  <label class="requestlabel">Request ID</label>

                  <CustomMultiSelect placeholder="Select Request Id" v-model="requestid.RequestIDValue"
                    :items="requestid.RequestIDOptions" @update:modelValue="RequestIDOnChange" ref="multiRef"
                    @blur="onDropdownBlur" />
                </div>
              </div>

              <div class="d-flex field" v-if="requestValue">
                <div class="common-heading">{{ requestidValue }}</div>

                <div class="ps-3">
                  <EditIcon />
                </div>
              </div>
            </b-col>
          </b-row>

          <div class="field mt-4" v-if="uploadedTableList.length != 0">
            <label class="mt-0">{{
              $t("PurchaseRequest.QuotationFile")
            }}</label>

            <b-row>
              <b-col lg="3" md="4" sm="6" cols="12" class="d-flex mb-3" v-for="item in uploadedTableList">
                <div class="fileuploadcard my-2" :title="item.fileName">
                  <div>
                    <p class="filenametxt">{{ item.fileName }}</p>

                    <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                      view
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>

          <b-row>
            <b-col class="position-relative prtable">
              <TabView class="tabview-custom" ref="tabview4" v-model:activeIndex="clases.ItemsReOrderTab">
                <TabPanel>
                  <template #header>
                    <i class="pi pi-align-left ps-3"></i>

                    <span>Items</span>
                  </template>
                  <div>
                    <!-- <b-row>
                      <b-col class="d-flex flex-row-reverse">
                        <div class="savedraftbtn">
                          <p @click="SaveDraft('PO')">Save as draft</p>
                        </div>
                      </b-col>
                    </b-row> -->
                    <b-row>
                      <b-col class="d-flex flex-row-reverse pt-3">
                        <p class="add-items d-flex d-flex-row-reverse" v-b-toggle.collapse-3>
                          + Add New
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-collapse id="collapse-3" :class="displayClass">
                          <Item @additemclick="AddItems" v-model:data-items="dataItems" :show-fields="showFields"
                            :addItemData="items" :commonItemProps="commonItemProps" @calculation="TotalGrossCalc"
                            :requestdata="requestdata" />
                        </b-collapse>
                      </b-col>
                    </b-row>
                    <b-row class="actioncardbg">
                      <b-col lg="4" md="4">
                        <div class="d-flex align-items-center justify-content-around">
                          <p class="selectedcount">
                            {{ POselectedProductCount }} Selected
                          </p>
                          <div>
                            <span class="p-input-icon-left card-search">
                              <i class="pi pi-search pb-0" />
                              <TextField @keyup="ItemSearchFunction()" v-model="SearchValue.inputValue" type="text"
                                placeholder="Search Item" clearable name="Search Item" :rules="{ required: false }"
                                id="Box Name" :required-icon="false" label="p" />
                            </span>
                          </div>
                          <!-- <div class="label-d-none field my-auto">
                            <span class="p-input-icon-right">
                              <i class="pi pi-search ml-2" />
                              <TextField @keyup="ItemSearchFunction()" v-model="SearchValue.inputValue" type="text"
                                placeholder="Search Item" clearable name="Search Item" :rules="{ required: false }"
                                id="Box Name" :required-icon="false" label="p" />
                            </span>
                          </div> -->
                        </div>
                      </b-col>
                      <!-- <b-col lg="3" md="3">
                        <div class="label-d-none field my-auto">
                          <span class="p-input-icon-right">
                            <i class="pi pi-search ml-2" />
                            <TextField @keyup="ItemSearchFunction()" v-model="SearchValue.inputValue" type="text"
                              placeholder="Search Item" clearable name="Search Item" :rules="{ required: false }"
                              id="Box Name" :required-icon="false" label="p" />
                          </span>
                        </div>
                      </b-col> -->
                      <!-- <b-col lg="2" md="2">
                        <div class="label-d-none field prtopo my-auto">
                          <CustomDropdown @update:modelValue="FilterCategoryOnChange"
                            v-model="FilterCategoryDropdown.CategoryId" :items="FilterCategoryDropdown.CategoryOptions"
                            :rules="{ required: false }" placeholder="Select Category" name="Selectcategory"
                            :required-icon="false" />
                        </div>
                      </b-col>
                      <b-col lg="2" md="2">
                        <div class="label-d-none field prtopo my-auto">
                          <CustomDropdown @update:modelValue="" v-model="FilterSupplierDropdown.SupplierId"
                            :items="FilterSupplierDropdown.SupplierOptions" :rules="{ required: false }"
                            placeholder="Select Supplier" name="Selectsupplier" :required-icon="false" />
                        </div>
                      </b-col> -->
                      <b-col lg="8" md="8" class="d-flex align-items-center justify-content-end gap-2">
                        <div class="label-d-none field prtopo my-auto">
                          <CustomDropdown @update:modelValue="FilterCategoryOnChange"
                            v-model="FilterCategoryDropdown.CategoryId" :items="FilterCategoryDropdown.CategoryOptions"
                            :rules="{ required: false }" placeholder="Select Category" name="Selectcategory"
                            :required-icon="false" />
                        </div>
                        <div class="label-d-none field prtopo my-auto">
                          <CustomDropdown @update:modelValue="" v-model="FilterSupplierDropdown.SupplierId"
                            :items="FilterSupplierDropdown.SupplierOptions" :rules="{ required: false }"
                            placeholder="Select Supplier" name="Selectsupplier" :required-icon="false" />
                        </div>
                        <AddButton btnname="Add" @Click="SupplierAdd" />

                        <AddButton class="blue-txt" btnname="Cancel" @Click="SupplierAddCancel" />
                      </b-col>
                    </b-row>
                    <SkeletonTableLoader :columns="POheaders" :loading="loading" />
                    <!-- {{ POItemTable }} -->
                    <POETableview v-if="param == 'PO' && !loading" :rowHover="true" filterDisplay="menu"
                      :loading="loading" responsiveLayout="scroll" :columns="POheaders"
                      :globalFilterFields="globalFilterFields" :data="POItemTable"
                      @selection="POselectedProductFunction" :selectionMode="IsPOObj.POTableSelectionMode"
                      @row-click="RowClick" :seriaNlumber="true">
                      <template v-slot:Add>
                        <span>
                          <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                        </span>
                      </template>
                      <template v-slot:field>
                        <span>
                          <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                        </span>
                      </template>
                      <template v-slot:BrandIdPO="{ data }">
                        <div class="label-d-none tablefield mb-0" @click="filterBrand(data, 0)">
                          <CustomDropdown :items="data.ItemBrandoption" v-model="data.Brand" :showClear="true"
                            @update:modelValue="">
                          </CustomDropdown>
                        </div>
                      </template>

                      <template v-slot:ModelNumberIdPO="{ data }">
                        <div class="label-d-none tablefield mb-0" @click="filterModelNumber(data, 0)">
                          <CustomDropdown :items="data.ItemModelNumberoption" v-model="data.ModelNumber"
                            :showClear="true" @update:modelValue="">
                          </CustomDropdown>
                        </div>
                      </template>

                      <template v-slot:SizeIdPO="{ data }">
                        <div class="label-d-none tablefield mb-0" @click="filterSize(data, 0)">
                          <CustomDropdown :items="data.ItemSizeoption" v-model="data.Size" :showClear="true"
                            @update:modelValue="">
                          </CustomDropdown>
                        </div>
                      </template>

                      <template v-slot:action="{ data }">
                        <span>
                          <EditIcon @click="IsItemEdit(data)" v-if="data.DocType != 5" />

                          <DeleteIcon @click="IsPOItemDelete(data)" v-if="data.DocType != 5" />
                        </span>
                      </template>
                    </POETableview>

                    <b-row v-if="SupplierInfo.length > 0">
                      <b-col>
                        <div class="supplierlistbg">
                          <div class="supplieractionbtnsbg">
                            <i @click="scrollBackward" class="pi pi-arrow-circle-left"></i>
                            <i @click="scrollForward" class="pi pi-arrow-circle-right"></i>
                          </div>
                          <div class="d-flex align-items-center justify-content-between w-90">
                            <div class="supplierdetails scroll-container" ref="scrollContainer">
                              <div class="suppliercardsbg" v-for="item in SupplierInfo">
                                <p>{{ item?.SupplierName }}</p>
                                <OrangeBadge :BadgeValue="item?.ItemCount" />
                              </div>
                            </div>
                            <div class="proceedbtn d-flex align-items-center ms-3">
                              <div class="savedraftbtn me-2">
                                <p @click="SaveDraft('PO')">Save as draft</p>
                              </div>
                              <!-- <Button :label="warningmsgcontent.SubmitButtonName" @click="IsSubmit('P')" /> -->
                              <Footer class="py-2" :goback="$router.back" :label="warningmsgcontent.SubmitButtonName"
                                @save="IsSubmit('P')" :cancelhide="false" :loading="ConvertToPOSaveloader" />
                            </div>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </TabPanel>
                <TabPanel v-if="param == 'PO' && IsPOObj.LPOTabHideAndShow == true">
                  <template #header>
                    <i class="pi pi-align-left ps-3"></i>

                    <span>LPO</span>
                  </template>
                  <div>
                    <!-- <b-row>
                      <b-col class="d-flex flex-row-reverse pt-3">
                        <p class="add-items d-flex d-flex-row-reverse" v-b-toggle.collapse-3>
                          + Add New
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-collapse id="collapse-3" :class="displayClass">
                          <Item @additemclick="AddItems" v-model:data-items="dataItems" :show-fields="showFields"
                            :addItemData="items" :commonItemProps="commonItemProps" @calculation="TotalGrossCalc"
                            :requestdata="requestdata" />
                        </b-collapse>

                      </b-col>
                    </b-row> -->

                    <SkeletonTableLoader :columns="LPOheaders" :loading="loading" />
                    <b-row class="pt-3 pb-5">
                      <b-col>
                        <AddButton btnname="+ Add items to the request" class="btn-class-name" @click="AddLPOItems" />
                      </b-col>
                    </b-row>
                    <LPOETableview v-if="!loading" :rowHover="true" filterDisplay="menu" :loading="loading"
                      responsiveLayout="scroll" :columns="LPOheaders" :data="LPOItemTable"
                      @selection="LPOselectedProductFunction" :selectionMode="true" @row-click="RowClick">
                      <template v-slot:Add>
                        <span>
                          <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                        </span>
                      </template>
                      <template v-slot:field>
                        <span>
                          <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                        </span>
                      </template>

                      <!--<template v-slot:BrandIdLPO="{ data }">
    <div class="label-d-none tablefield mb-0" @click="filterBrand(data, 1)">
    
        <CustomDropdown :items="data.ItemBrandoption" v-model="data.BrandLPO" :showClear="false" @update:modelValue="">
    
        </CustomDropdown>
    
    </div>
</template>

<template v-slot:ModelNumberIdLPO="{ data }">
    <div class="label-d-none tablefield mb-0" @click="filterModelNumber(data, 1)">
    
        <CustomDropdown :items="data.ItemModelNumberoption" v-model="data.ModelNumberLPO" :showClear="false" @update:modelValue="">
    
        </CustomDropdown>
    
    </div>
</template>

<template v-slot:SizeIdLPO="{ data }">
    <div class="label-d-none tablefield mb-0" @click="filterSize(data, 1)">
    
        <CustomDropdown :items="data.ItemSizeoption" v-model="data.SizeLPO" :showClear="false" @update:modelValue="">
    
        </CustomDropdown>
    
    </div>
</template>-->

                      <!--<template v-slot:action="{ data }">
    <span>
    
                              <EditIcon @click="IsItemEdit(data)" />
    
                              <DeleteIcon @click="IsPOItemDelete(data)" />
    
                            </span>
</template>-->
                    </LPOETableview>
                  </div>
                </TabPanel>
              </TabView>
            </b-col>
          </b-row>
        </b-row>
      </div>
    </b-container>
  </div>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <POCreateSuccessully :visible="POsuccesspop" @ok="POclosetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <WarningMessage :visible="wariningPopup" :content="warningmsgcontent.warningcontent" @ok="ClosewariningPopup()" />
  <Toast />
</template>

<script lang="ts">
import { useToast } from "primevue/usetoast";
import moment from "moment";
import BackToMasters from "../../../../../components/FormComponents/BacktoMaster.vue";
import CustomDropdown from "../../../../../components/FormComponents/Dropdown.vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import Badge from "primevue/badge";
import AddItemsVue from "../../../components/Transaction/AddItems.vue";
import { defineComponent, ref, computed, onMounted, reactive } from "vue";
import NTableview from "../../../../../components/FormComponents/NormalTable.vue";
import PRETableview from "../../../../../components/FormComponents/EditableTable.vue";
import POETableview from "../../../../../components/FormComponents/EditableTable.vue";
import LPOETableview from "../../../../../components/FormComponents/EditableTable.vue";
import ReorderETableview from "../../../../../components/FormComponents/EditableTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Item from "../../../components/Transaction/Item.vue";
import { useRoute, useRouter } from "vue-router";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import cancel from "../../../../../components/GeneralButtons/CancelButtton.vue";
import RequestId from "../../../components/Transaction/stockwithoutaffect/RequestId.vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import CustomMultiSelect from "../../../../../components/FormComponents/MultiSelectDropdown.vue";
import common from "../../../Service/CommonService";

import WithoutStockService from "../../../Service/WithoutStockAffectService";
import CreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import POCreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AddItemConfirmation from "../../../../../components/FormComponents/AddItemsConfirmation.vue";
import WarningMessage from "../../../../../components/FormComponents/WarningMessage.vue";
import SupplierService from "../../../Service/SupplierMaster";

import SupplierCategoryService from "../../../Service/SupplierCategoryMappingService";
import QuoteConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import PIConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";

import StoreService from "../../../Service/StoreService";
import PaymentTermsService from "../../../Service/PaymentTermsService";
import DeliveryTermsService from "../../../Service/DeliveryTermsService";
import ItemConfigurationService from "../../../Service/ItemConfiguration";
import ItemService from "../../../Service/ItemMasService";
import SupplierCategory from "../../../Service/SupplierCategoryMappingService";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import StoreDropDown from "../../../components/DropDown/StoreDropDown.vue";
import { setupHistoryManagement } from "../../../Service/HistoryManage";
import StockWOFileUploadServices from "../../../Service/StockWOFileUploadService";

export default defineComponent({
  components: {
    StoreDropDown,
    Badge,
    AddItemsVue,
    Item,
    PRETableview,
    POETableview,
    LPOETableview,
    ReorderETableview,
    NTableview,
    Footer,
    cancel,
    BackToMasters,
    Headerlayout,
    RequestId,
    TextField,
    CustomMultiSelect,
    CreateSuccessully,
    POCreateSuccessully,
    UpdatedSuccessfully,
    AddItemConfirmation,
    WarningMessage,
    CustomDropdown,
    QuoteConfirmation,
    PIConfirmation,
    SkeletonTableLoader,
  },
  props: {
    showone: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    debugger;

    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    const toast = useToast();
    let List = ref([]);
    let loading = ref(false);
    let ConvertToPOSaveloader = ref(false);
    let showitemfield = ref(false);
    const items: any = ref([]);
    const displayClass = ref("");
    const ItemTable: any = ref([]);
    const POItemTable: any = ref([]);

    const LPOItemTable: any = ref([]);
    const POHiddenItemTable: any = ref([]);
    const POHiddenItemArray: any = ref([]);
    let ItemRemove: any = ref([]);
    let requestdata: any = ref();
    const ReOrderData: any = ref([]);
    const router = useRouter();
    const route = useRoute();
    const successpop = ref(false);
    const POsuccesspop = ref(false);
    const updatepop = ref(false);
    const wariningPopup = ref(false);
    const selectedProduct: any = ref([]);
    const LPOselectedProduct: any = ref([]);
    const POselectedProduct: any = ref([]);
    const POselectedProductCount: any = ref(0);

    const SupplierInfo: any = ref([]);

    let requestdropdown = ref(true);
    let requestValue = ref(false);
    let requestidValue = ref("");
    const dataItems = ref({});

    let StoreDropdownDisable = ref(false);
    let filtercateObj: any = ref([]);

    let IsPOObj = ref({
      IsPOUpdate: 0,
      SaveAsDraft: 0,
      LPOTabHideAndShow: false,
      POTableSelectionMode: false,
    });

    const commonItemProps = ref({
      storeId: "",
      type: 0,
      POFlag: 1,
    });

    let clases = ref({
      ItemsReOrderTab: 0,
      WithAndWithoutRateTab: 0,
    });

    // For Get Current date and time in sql server format
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const milliseconds = now.getMilliseconds();

    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}T${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${milliseconds
          .toString()
          .padStart(3, "0")}`;
    // end

    const ObjVal = ref({
      Id: 0,
      DocType: "",
      DocNo: "",
      //DocDate: "2023-03-15T13:40:56.139Z",
      DocDate: formattedDate,
      RefId: 0,
      RefNo: "",
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      SupplierId: 0,
      Amount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      PaymentTermsId: 0,
      DeliveryTermsId: 0,
      IsDraft: 0,

      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsServiceLevel: 0,
    });

    const ObjPRInfo = ref({
      DocNo: "",
      CreatedByName: "",
      DocDate: "",
    });

    const grossvalues = ref({
      grossamount: 0.0,
      taxamount: 0.0,
      totaldiscountamount: 0.0,
      transportcharges: 0.0,
      servicecharges: 0.0,
      othercharges: 0.0,
      netamount: 0.0,
      totalqty: 0.0,
    });

    const BrandDropdownPO: any = ref({
      ItemBrandoption: [],
    });

    const ModelNumberDropdownPO: any = ref({
      ItemModelNumberoption: [],
    });

    const SizeDropdownPO: any = ref({
      ItemSizeoption: [],
    });

    const BrandDropdownLPO: any = ref({
      ItemBrandoption: [],
    });

    const ModelNumberDropdownLPO: any = ref({
      ItemModelNumberoption: [],
    });

    const SizeDropdownLPO: any = ref({
      ItemSizeoption: [],
    });

    let showFields = {
      // Category: true,
      Name: {
        show: true,
        require: true,
      },
      Batch: {
        show: false,
        require: false,
      },
      PackSize: {
        show: true,
        require: true,
      },
      UnitRate: {
        show: true,
        require: true,
      },
      Qty: {
        show: true,
        require: true,
      },
      // MRP: false,
      //  Discount: false,
      AvailQty: {
        show: false,
        require: false,
      },
      IssuedQty: {
        show: false,
        require: false,
      },
      RequestedQty: {
        show: false,
        require: false,
      },
      Brand: {
        show: true,
        require: false,
      },
      ModelNumber: {
        show: true,
        require: false,
      },
      Size: {
        show: true,
        require: false,
      },
    };

    function ShowItems() {
      showitemfield.value = true;
    }

    const headers = [
      {
        header: "Category",
        field: "ItemCategory1",
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "Code",
        field: "ItemProductId",
        class: "smallwidth",
      },
      // {
      //   header: "HSN Code",
      //   field: "HSNCode",
      // },
      {
        header: "Name",
        field: "Itemname1",
        bodyclass: "boldclass",
      },
      {
        header: "Brand / Model /Size",
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
      },
      {
        header: "Avl Qty",
        field: "StockInHand",
      },
      {
        header: "Reorder Level",
        field: "ReOrderLevel",
      },
      {
        header: "Required Qty",
        field: "RequiredQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "Req Qty",
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },

      {
        header: "Supplier",
        field: "SupplierName",
        class: "smallwidth",
      },

      {
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
      },
    ];

    const POheaders = [
      {
        header: "Category",
        field: "ItemCategory1",
        class: "smallwidth coumnfreezeleft1",
      },
      {
        header: "Code",
        field: "ItemProductId",
        class: "smallwidth coumnfreezeleft2",
      },
      {
        header: "Name",
        field: "Itemname1",

        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth coumnfreezeleft3",
      },
      {
        header: "Supplier",
        field: "SupplierName",
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "Brand",
        field: "",
        slot: "BrandIdPO",
        class: "mediumwidth",
      },
      {
        header: "Model",
        field: "",
        slot: "ModelNumberIdPO",
        class: "mediumwidth",
      },
      {
        header: "Size",
        field: "",
        slot: "SizeIdPO",
        class: "mediumwidth",
      },
      {
        header: "UOM",
        field: "UOMName",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "Avl Qty",
        field: "StockInHand",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      // {
      //   header: "Required",
      //   field: "RequiredQuantity",
      //   bodyclass: "boldclass",
      // },
      // {
      //   header: "PackSize Name",
      //   field: "PackSizename1",
      //   class: "smallwidth"
      // },
      // {
      //   header: "PackSize Qty",
      //   field: "PackSizeQty",
      //   bodyclass: "right_td",
      //   class: "smallwidth"
      // },
      {
        header: "Unit Rate",
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth",
        fieldDisplay: "false",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Qty",
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "Rate",
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth",
        fieldDisplay: "false",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
      },
    ];

    const LPOheaders = [
      {
        header: "Category",
        field: "ItemCategory1",
        class: "smallwidth newcolumnfreezeleft1",
      },
      {
        header: "Code",
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft2",
      },
      {
        header: "Name",
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth newcolumnfreezeleft3",
      },
      {
        header: "Supplier",
        field: "POSupplierName",
        class: "smallwidth",
      },
      {
        header: "Brand",
        field: "BrandName",
        //slot: "BrandIdLPO",
        class: "mediumwidth newcolumnfreezeleft4",
      },
      {
        header: "Model",
        field: "ModelNumberName",
        //slot: "ModelNumberIdLPO",
        class: "mediumwidth",
      },
      {
        header: "Size",
        field: "SizeName",
        //slot: "SizeIdLPO",
        class: "mediumwidth",
      },
      {
        header: "UOM",
        field: "POUOMName",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "Avl Qty",
        field: "StockInHand",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      // {
      //   header: "Req Qty",
      //   field: "RequiredQuantity",
      //   bodyclass: "right_td",
      //   class: "smallwidth"
      // },
      // {
      //   header: "PackSize Name",
      //   field: "POPackSizename",
      //   class: "smallwidth"
      // },
      // {
      //   header: "PackSize Qty",
      //   field: "POPackSizeQty",
      //   bodyclass: "right_td",
      //   class: "smallwidth"
      // },
      {
        header: "Unit Rate",
        field: "POUnitRate",
        bodyclass: "right_td",
        class: "smallwidth",
        fieldDisplay: "false",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Qty",
        field: "POQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "Rate",
        field: "PORate",
        bodyclass: "right_td",
        class: "smallwidth",
        fieldDisplay: "false",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      // {
      //   header: "Last Purchase Price",
      //   field: "LastPurchasePrice",
      //   bodyclass: "right_td",
      //   class: "smallwidth"
      // },

      // {
      //   class: "filterdisplaynone last-column-position",
      //   fieldDisplay: "false",
      //   field: "action",
      //   header: "",
      //   slot: "action",
      //   frozencolumn: true,
      //   sortable: false,
      // },
    ];

    //ReOrder Level Table
    const ReOrderheaders = [
      {
        header: "Item Code",
        field: "ItemProductId",
      },
      // {
      //   header: "HSN Code",
      //   field: "HSNCode",
      // },
      {
        header: "Name",
        field: "Itemname1",
        bodyclass: "boldclass",
      },
      {
        header: "Reorder level",
        field: "ReOrderLevel",
      },
      {
        header: "Quantity",
        field: "ItemQuantity",
        bodyclass: "boldclass",
      },

      {
        field: "action",
        header: "Action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
      },
    ];

    const paramValue = computed(() => {
      return route.query.param as string;
    });
    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    const AddData = ref<string[]>([]);
    const handleValues = (valuesArray: string[]) => {
      debugger;
      AddData.value = valuesArray;
      console.log(AddData.value);
    };

    let Entitydata = ref();
    let QueryStringValue3: any = route.query;
    QueryStringValue3 = JSON.parse(QueryStringValue3.data);
    let StoreID = QueryStringValue3["StoreId"];
    let StockWoTransTMId = QueryStringValue3["StockWoTransTMId"];

    let fromStoreBranchMapId =
      Number(QueryStringValue3["storebranchmapid"]) ?? 0;

    commonItemProps.value.storeId = QueryStringValue3["StoreId"];
    Entitydata.value = Number(QueryStringValue3.EntityId) ?? 0;
    let param = route.query.param;

    onMounted(() => {
      debugger;
      ReadyFunction();
    });
    let uploadedTableList: any = ref([]);

    function fileviewer(data) {
      debugger;
      const newTabUrl = data;
      window.open(newTabUrl, "_blank");
    }
    async function ReadyFunction() {
      debugger;
      await LoadPRInformations();
      if (QueryStringValue3["StockWoTransTMId"] != "0" && param == "PO") {
        warningmsgcontent.value.TitleContent = "Raise a PO";
        warningmsgcontent.value.SubmitButtonName = "Convert to PO";
        StoreDropdownDisable.value = true;
        await LoadItemConfigurations();
        IsShowByStockTransIdPO(QueryStringValue3["StockWoTransTMId"]);
        const FileUploadresult =
          await StockWOFileUploadServices.getStockWOFileById(
            QueryStringValue3["StockWoTransTMId"]
          );
        if (FileUploadresult["result"].length > 0) {
          for (let i = 0; i < FileUploadresult["result"].length; i++) {
            let Fileobj = {};
            (Fileobj["url"] =
              FileUploadresult["result"][i].FileName.split("/FileUpload/")[1]),
              (Fileobj["fileName"] =
                FileUploadresult["result"][i].FileName.split("/").pop()),
              (Fileobj["fileType"] = Fileobj["url"].split("/")[0]),
              (Fileobj["fullPath"] = FileUploadresult["result"][i].FileName),
              (Fileobj["Id"] = FileUploadresult["result"][i].Id),
              uploadedTableList.value.push(Fileobj);
          }
        } else {
          uploadedTableList.value = [];
        }
      }
    }

    async function LoadPRInformations() {
      debugger;
      const result = await WithoutStockService.GetByStockWOTransId(
        QueryStringValue3["StockWoTransTMId"]
      );

      ObjVal.value.DocNo = result["result"][0]?.DocNo;
      ObjPRInfo.value.DocNo = result["result"][0]?.DocNo;
      ObjPRInfo.value.DocDate = result["result"][0]?.DocDateHR;
      ObjPRInfo.value.CreatedByName = result["result"][0]?.CreatedByName;
    }

    //Load Item Configuration

    async function LoadItemConfigurations() {
      debugger;
      try {
        const response = await ItemConfigurationService.List();

        BrandDropdownPO.value.ItemBrandoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == HospitalId &&
              f.ICTypeId == 1
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });

        ModelNumberDropdownPO.value.ItemModelNumberoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == HospitalId &&
              f.ICTypeId == 2
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });

        SizeDropdownPO.value.ItemSizeoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == HospitalId &&
              f.ICTypeId == 3
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });

        BrandDropdownLPO.value.ItemBrandoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == HospitalId &&
              f.ICTypeId == 1
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });

        ModelNumberDropdownLPO.value.ItemModelNumberoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == HospitalId &&
              f.ICTypeId == 2
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });

        SizeDropdownLPO.value.ItemSizeoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == HospitalId &&
              f.ICTypeId == 3
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }

    async function filterBrand(data, NumVal) {
      debugger;
      console.log(data);
      const response = await ItemDetailsById(data.ItemId);
      if (response["result"].Brand != "") {
        if (NumVal == 0) {
          data.ItemBrandoption = BrandDropdownPO.value.ItemBrandoption.filter(
            (x) => response["result"].Brand.split(",").includes(String(x.Id))
          );
          // if (data.ItemBrandoption.length == 0) {
          //   data.ItemBrandoption = BrandDropdownPO.value.ItemBrandoption;
          // }
        } else if (NumVal == 1) {
          data.ItemBrandoption = BrandDropdownLPO.value.ItemBrandoption.filter(
            (x) => response["result"].Brand.split(",").includes(String(x.Id))
          );
          // if (data.ItemBrandoption.length == 0) {
          //   data.ItemBrandoption = BrandDropdownLPO.value.ItemBrandoption;
          // }
        }
      } else {
        data.ItemBrandoption = [];
      }
    }

    async function filterModelNumber(data, NumVal) {
      debugger;
      console.log(data);

      const response = await ItemDetailsById(data.ItemId);
      if (response["result"].ModelNumber != "") {
        if (NumVal == 0) {
          data.ItemModelNumberoption =
            ModelNumberDropdownPO.value.ItemModelNumberoption.filter((x) =>
              response["result"].ModelNumber.split(",").includes(String(x.Id))
            );

          // if (data.ItemModelNumberoption.length == 0) {
          //   data.ItemModelNumberoption =
          //     ModelNumberDropdownPO.value.ItemModelNumberoption;
          // }
        } else if (NumVal == 1) {
          data.ItemModelNumberoption =
            ModelNumberDropdownLPO.value.ItemModelNumberoption.filter((x) =>
              response["result"].ModelNumber.split(",").includes(String(x.Id))
            );
          // if (data.ItemModelNumberoption.length == 0) {
          //   data.ItemModelNumberoption =
          //     ModelNumberDropdownLPO.value.ItemModelNumberoption;
          // }
        }
      } else {
        data.ItemModelNumberoption = [];
      }
    }

    async function filterSize(data, NumVal) {
      debugger;
      console.log(data);

      const response = await ItemDetailsById(data.ItemId);
      if (response["result"].Size != "") {
        if (NumVal == 0) {
          data.ItemSizeoption = SizeDropdownPO.value.ItemSizeoption.filter(
            (x) => response["result"].Size.split(",").includes(String(x.Id))
          );

          // if (data.ItemSizeoption.length == 0) {
          //   data.ItemSizeoption = SizeDropdownPO.value.ItemSizeoption;
          // }
        } else if (NumVal == 1) {
          data.ItemSizeoption = SizeDropdownLPO.value.ItemSizeoption.filter(
            (x) => response["result"].Size.split(",").includes(String(x.Id))
          );

          // if (data.ItemSizeoption.length == 0) {
          //   data.ItemSizeoption = SizeDropdownLPO.value.ItemSizeoption;
          // }
        }
      } else {
        data.ItemSizeoption = [];
      }
    }

    async function ItemDetailsById(ItemId) {
      debugger;
      return await ItemService.Edit(ItemId, HospitalId);
    }

    //Load store
    const StoreDropdown = ref({
      StoreOptions: [],
      StoreBrMapId: ref(),
      StoreId: ref(),
    });

    const Loadstores = async () => {
      const result = await StoreService.getStoreByStoreId(
        StoreID,
        usersData.OrganizationId,
        QueryStringValue3["BranchId"]
      );
      console.log(result);

      StoreDropdown.value.StoreOptions = result["result"].map((item) => {
        item.name = item.Name;
        item.value = item.StoreId;
        return item;
      });
      console.log(requestid.value.RequestIDOptions);
    };

    function StoreOnChange() {
      debugger;

      if (
        StoreDropdown.value.StoreId != null &&
        StoreDropdown.value.StoreId != 0
      ) {
        requestid.value.RequestIDOptions = [];
        requestid.value.RequestIDValue = "";
        ItemTable.value = [];
        items.value = [];
        LoadRequestID("N", "");
      }
    }

    const requestid = ref({
      RequestIDOptions: [],
      RequestIDValue: "",
    });

    // Load Request Id
    async function LoadRequestID(Status, value) {
      debugger;
      if (
        StoreDropdown.value.StoreId != null &&
        StoreDropdown.value.StoreId != 0
      ) {
        let PValues = ref({
          statusValue: Status == "N" ? "0,3,5" : "0,3,4,5",
          DocType: 1,
        });

        const result = await WithoutStockService.GetRequestIDs(
          StoreDropdown.value.StoreId.Id,
          "FM",
          PValues.value.statusValue,
          PValues.value.DocType,
          0
        );
        console.log(result);

        if (Status == "N") {
          requestid.value.RequestIDOptions = result["result"].map((item) => {
            item.name = item.DocNo;
            item.value = item.Id;
            return item;
          });
        } else {
          requestid.value.RequestIDOptions = result["result"]
            .map((item) => {
              item.name = item.DocNo;
              item.value = item.Id;
              return item;
            })
            .filter(
              (item) =>
                (item.DocType == 1 && item.Status == 0) ||
                (item.DocType == 1 && item.Status == 5) ||
                (item.Status == 4 && value.includes(item.Id))
            );
        }

        console.log(requestid.value.RequestIDOptions);
      }
    }

    //Request Id OnChange

    let RequestId = "";
    let SavingArray: any = ref([]);

    async function RequestIDOnChange(requestId) {
      debugger;

      let nonExistingValues = requestId.filter(
        (item) => !SavingArray.value.includes(item)
      );

      RequestId = nonExistingValues.toString();

      console.log(RequestId);
      if (RequestId != "") {
        const result = await WithoutStockService.GetItemsByRequstIdForPIPR(
          RequestId
        );

        SavingArray.value = requestId;

        result["result"] = result["result"].map((item) => {
          item.StockInHand = item.StockInHand1;
          return item;
        });

        console.log(result["result"].length);

        Object.values(result["result"]).forEach((items: any) => {
          items.RequiredQuantity =
            Number(items.ReOrderLevel) - Number(items.StockInHand);
        });

        if (result["result"].length > 0) {
          Object.values(items.value).forEach((item1: any) => {
            Object.values(result["result"]).forEach((items: any) => {
              if (item1.ItemId == items.ItemId) {
                item1.ItemQuantity =
                  Number(item1.ItemQuantity) + Number(items.ItemQuantity);
              }
            });
          });

          result["result"] = result["result"].filter(
            (value) => !items.value.some((i1) => i1.ItemId == value.ItemId)
          );

          for (let i = 0; i < result["result"].length; i++) {
            let obj = {};
            Object.assign(obj, result["result"][i]);
            console.log(obj);
            items.value.push(obj);
          }

          requestdata.value = items.value;
          ItemTable.value = items.value;
        }

        let arr = requestid.value.RequestIDOptions.filter((item: any) =>
          requestid.value.RequestIDValue.includes(item.value)
        );

        let arr1 = arr.map((item: any) => item.name).toString();
        console.log(arr1);
        requestidValue.value = arr1;
      }
    }

    // const AddItems = (value) => {
    async function AddItems(value) {
      debugger;
      console.log(value);

      items.value = value;

      if (param == "PO") {
        value = value.map((item) => {
          item.ItemBrandoption = BrandDropdownPO.value.ItemBrandoption;
          item.ItemModelNumberoption =
            ModelNumberDropdownPO.value.ItemModelNumberoption;
          item.ItemSizeoption = SizeDropdownPO.value.ItemSizeoption;

          return item;
        });

        POItemTable.value = [];
        POHiddenItemTable.value = [];

        POItemTable.value = [...POItemTable.value, ...value];

        POHiddenItemTable.value = [...POHiddenItemTable.value, ...value];

        ///
        value.forEach((item) => {
          filtercateObj.value.push({
            ItemCategory1: item.ItemCategory1,
            CategoryId: item.CategoryId,
          });
          LoadFilterCategory(filtercateObj.value);
        });
        ///

        LPOItemTable.value = value
          .filter((item) => item.POSupplierId !== 0)
          .map((item) => {
            item.BrandLPO = item.Brand;
            item.ModelNumberLPO = item.ModelNumber;
            item.SizeLPO = item.Size;
            return item;
          });
      }
    }

    let SearchValue = ref({
      inputValue: "",
    });

    function ItemSearchFunction() {
      debugger;
      POselectedProduct.value = [];

      let SearchText = SearchValue.value.inputValue;
      let regex = new RegExp(SearchText, "i");

      try {
        POItemTable.value = POHiddenItemTable.value.filter(
          (f) => regex.test(f.Itemname1) || regex.test(f.ItemProductId)
        );

        console.log(POItemTable);
      } catch (error) {
        alert(error);
      }
    }

    // Load Filter Category
    const FilterCategoryDropdown: any = ref({
      CategoryOptions: [],
      CategoryId: ref(),
    });

    async function LoadFilterCategory(CategoryArray) {
      debugger;

      const uniqueCategoryItems = CategoryArray.filter(
        (item) =>
          !FilterCategoryDropdown.value.CategoryOptions.some(
            (option) => option.value === item.CategoryId
          )
      );

      FilterCategoryDropdown.value.CategoryOptions = [
        ...FilterCategoryDropdown.value.CategoryOptions,
        ...uniqueCategoryItems.map((item) => ({
          name: item.ItemCategory1,
          value: item.CategoryId,
        })),
      ];

      console.log(FilterCategoryDropdown.value.CategoryOptions);
    }

    function FilterCategoryOnChange(CategoryId) {
      debugger;
      FilterSupplierDropdown.value.SupplierOptions = [];
      FilterSupplierDropdown.value.SupplierId = ref();
      if (CategoryId != null) {
        FilterCategoryDropdown.value.CategoryId = CategoryId;

        LoadFilterSuppliers();

        let regex = new RegExp(CategoryId, "i");
        POItemTable.value = POHiddenItemTable.value.filter((f) =>
          regex.test(f.CategoryId)
        );

        IsPOObj.value.POTableSelectionMode = true;
      } else {
        ItemSearchFunction();
      }
    }

    // Load Filter Supplier
    const FilterSupplierDropdown: any = ref({
      SupplierOptions: [],
      SupplierId: ref(),
    });

    async function LoadFilterSuppliers() {
      debugger;

      const response = await SupplierCategory.GetSupplierByMultipleCategory(
        FilterCategoryDropdown.value.CategoryId,
        QueryStringValue3["BranchId"],
        usersData.OrganizationId
      );

      FilterSupplierDropdown.value.SupplierOptions = response["result"].map(
        (item) => {
          item.name = item.SupplierName;
          item.value = item.SupplierId;
          item.CategoryId = item.ItemCategoryId;
          return item;
        }
      );
    }

    const selectedIndices: any = ref([]);

    function POselectedProductFunction(value) {
      debugger;

      POselectedProduct.value = value;
      POselectedProductCount.value = POselectedProduct.value.length;

      // Get the indices of selected rows
      selectedIndices.value = [];
      for (let i = 0; i < value.length; i++) {
        selectedIndices.value.push(POItemTable.value.indexOf(value[i]));
      }

      // Now selectedIndices array contains the indices of selected rows
      console.log(selectedIndices);
    }

    function SupplierAddCancel() {
      debugger;
      FilterCategoryOnChange(null);
      SupplierInformation();
    }

    const POCalcDetails: any = ref({
      TotalAmount: 0.0,
    });

    async function SupplierAdd() {
      debugger;
      let TempMsg =
        POselectedProduct.value.length == 0
          ? "Select Items"
          : FilterSupplierDropdown.value.SupplierId == null ||
            FilterSupplierDropdown.value.SupplierId == 0
            ? "Choose Supplier"
            : "";

      if (TempMsg != "") {
        toast.add({
          severity: "info",
          summary: TempMsg,
          detail: "",
          life: 3000,
        });
      } else {
        //ItemTable

        let SupObj = FilterSupplierDropdown.value.SupplierOptions.find(
          (item) => item.SupplierId == FilterSupplierDropdown.value.SupplierId
        );

        // Map ItemTable for selected indices
        // POItemTable.value = POItemTable.value.map((item, index) => {
        POItemTable.value = await Promise.all(
          POItemTable.value.map(async (item, index) => {
            if (selectedIndices.value.includes(index)) {
              let existingItems = POHiddenItemTable.value.filter(
                (existingItem) => existingItem.SupplierId === SupObj.SupplierId
              );

              if (existingItems.length > 0) {
                item.DocNo = existingItems[0].DocNo;
                item.StockWOTransId = existingItems[0].StockWOTransId;
                item.RefId = existingItems[0].RefId;
                item.RefNo = existingItems[0].RefNo;
              } else {
                if (item.DocType == 18) {
                  item.StockWOTransId = 0;
                  item.RefId = 0;
                } else if (item.DocType == 5) {
                  item.StockWOTransId = 0;
                } else {
                  item.StockWOTransId = 0;
                }
              }

              item.SupplierName = SupObj.SupplierName;
              item.SupplierId = SupObj.SupplierId;

              if (SupObj.SupplierId) {
                let LastPoUnitRate = await GetItemLastPOUnitRate(
                  SupObj.SupplierId,
                  item.ItemId
                );

                if (LastPoUnitRate) {
                  item.UnitRate = LastPoUnitRate;
                  item.Rate = Number(item.ItemQuantity * item.UnitRate).toFixed(
                    2
                  );
                }
              }

              // tax calculations
              if (item.DocType != 4 && item.DocType != 5) {
                item.Purchasetaxamount = Number(
                  (item.PurchasePercentage * item.Rate) / 100
                ).toFixed(2);
                if (usersData.BranchStateId != SupObj?.SuplierState) {
                  item.SGSTTax = 0;
                  item.SGSTTaxAmount = 0.0;

                  item.CGSTTax = 0;
                  item.CGSTTaxAmount = 0.0;

                  item.IGSTTax = Number(item.PurchasePercentage);
                  item.IGSTTaxAmount = Number(
                    (item.PurchasePercentage * item.Rate) / 100
                  ).toFixed(2);
                } else {
                  item.SGSTTax = Number(item.PurchasePercentage) / 2;
                  item.SGSTTaxAmount = Number(
                    Number(item.Purchasetaxamount) / 2
                  ).toFixed(2);

                  item.CGSTTax = Number(item.PurchasePercentage) / 2;
                  item.CGSTTaxAmount = Number(
                    Number(item.Purchasetaxamount) / 2
                  ).toFixed(2);

                  item.IGSTTax = 0;
                  item.IGSTTaxAmount = 0.0;
                }

                item.Amount = Number(
                  Number(item.Rate) +
                  Number(item.SGSTTaxAmount) +
                  Number(item.CGSTTaxAmount) +
                  Number(item.IGSTTaxAmount)
                ).toFixed(2);
              }

              //
            }
            return item;
          })
        );

        POCalcDetails.value.TotalAmount = 0.0;
        for (let i = 0; i < POItemTable.value.length; i++) {
          POCalcDetails.value.TotalAmount += parseFloat(
            POItemTable.value[i]["Rate"]
          );
        }

        IsPOObj.value.POTableSelectionMode = false;

        FilterCategoryOnChange(null);
        SupplierInformation();

        console.log(SupObj);
      }
    }

    async function GetItemLastPOUnitRate(SupplierId, ItemId) {
      debugger;
      let PODocType = "4,5";
      const response = await WithoutStockService.GetUnitRateByPO(
        PODocType,
        StoreID,
        SupplierId,
        ItemId
      );
      debugger;
      if (response) {
        return Number(response).toFixed(2);
      } else {
        console.log(response);
      }
    }

    function SupplierInformation() {
      debugger;
      // Count rows for each supplier
      const supplierRowCount = {};
      POItemTable.value.forEach((item) => {
        const supplierId = item.SupplierId;
        if (supplierId) {
          if (!supplierRowCount[supplierId]) {
            supplierRowCount[supplierId] = {
              SupplierName: item.SupplierName,
              ItemCount: 0,
            };
          }
          supplierRowCount[supplierId].ItemCount++;
        }
      });

      // Convert supplierRowCount object to an array of supplier counts
      SupplierInfo.value = Object.values(supplierRowCount);

      console.log("SupplierInfo", SupplierInfo.value);
    }

    let ExistingSupplier: any = ref([]);
    let RemoveSupplier: any = ref([]);

    function AddLPOItems() {
      debugger;

      Object.values(POItemTable.value).forEach((x: any) => {
        Object.values(LPOselectedProduct.value).forEach((y: any) => {
          if (
            x.ItemId == y.ItemId &&
            x.Brand == y.BrandLPO &&
            x.ModelNumber == y.ModelNumberLPO &&
            x.Size == y.SizeLPO
          ) {
            if (x.SupplierId != 0) {
              ExistingSupplier.value.push(y);
            } else {
              x.SupplierId = y.POSupplierId;
              x.SupplierName = y.POSupplierName;
              x.UOM = y.POUOM;
              x.UOMName = y.POUOMName;
              x.PackSizeId = y.POPackSizeId;
              x.PackSizename1 = y.POPackSizename;
              x.PackSizeQty = y.POPackSizeQty;
              x.UnitRate = Number(y.POUnitRate).toFixed(2);
              x.Rate = Number(x.ItemQuantity * y.POUnitRate).toFixed(2);

              RemoveSupplier.value.push(y);
            }
          } else {
            console.log(x);
          }
        });
      });

      if (ExistingSupplier.value.length > 0) {
        let supplierNames = ExistingSupplier.value
          .map((s) => s.SupplierName)
          .join(", ");
        let userResponse = confirm(
          `Suppliers already exist for the following items: ${supplierNames}. Do you want to continue?`
        );

        if (userResponse) {
          Object.values(POItemTable.value).forEach((x: any) => {
            Object.values(ExistingSupplier.value).forEach((y: any) => {
              if (
                x.ItemId == y.ItemId &&
                x.Brand == y.BrandLPO &&
                x.ModelNumber == y.ModelNumberLPO &&
                x.Size == y.SizeLPO
              ) {
                x.SupplierId = y.POSupplierId;
                x.SupplierName = y.POSupplierName;
                x.UOM = y.POUOM;
                x.UOMName = y.POUOMName;
                x.PackSizeId = y.POPackSizeId;
                x.PackSizename1 = y.POPackSizename;
                x.PackSizeQty = y.POPackSizeQty;
                x.UnitRate = Number(y.POUnitRate).toFixed(2);
                x.Rate = Number(x.ItemQuantity * y.POUnitRate).toFixed(2);

                RemoveSupplier.value.push(y);
              } else {
                console.log(ExistingSupplier.value);
              }
            });
          });
        } else {
          alert("Operation cancelled by the user.");
          return;
        }
      }

      LPOselectedProduct.value = [];

      if (RemoveSupplier.value.length > 0) {
        LPOItemTable.value = LPOItemTable.value.filter((x: any) => {
          return !Object.values(RemoveSupplier.value).some((y: any) => {
            return (
              x.ItemId === y.ItemId &&
              x.Brand === y.BrandLPO &&
              x.ModelNumber === y.ModelNumberLPO &&
              x.Size === y.SizeLPO
            );
          });
        });
      }

      // if (RemoveSupplier.value.length > 0) {
      //   for (let i = LPOItemTable.value.length - 1; i >= 0; i--) {
      //     let x = LPOItemTable.value[i];

      //     for (let j = 0; j < RemoveSupplier.value.length; j++) {
      //       let y = RemoveSupplier.value[j];

      //       if (
      //         x.ItemId === y.ItemId &&
      //         x.Brand === y.BrandLPO &&
      //         x.ModelNumber === y.ModelNumberLPO &&
      //         x.Size === y.SizeLPO
      //       ) {
      //         LPOItemTable.value.splice(i, 1); // Remove the element
      //         break; // Exit inner loop as item is already removed
      //       }
      //     }
      //   }
      // }
    }

    //Load Items by StockWoTrans Id
    async function IsShowByStockTransId(StockTransTMId) {
      debugger;

      const result = await WithoutStockService.GetByStockWOTransId(
        StockTransTMId
      );

      result["result"] = result["result"].map((item) => {
        item.SupplierId = item.ItemSupplierId;
        item.SupplierName = item.ItemSupplierName;
        return item;
      });

      items.value = result["result"];
      ItemTable.value = result["result"];

      StoreDropdown.value.StoreId = result["result"][0]["FromStore"];
      StoreDropdown.value.StoreBrMapId =
        result["result"][0]["FromStoreBrMapId"];

      await LoadRequestID("E", result["result"][0]["RefNo"]);
      requestid.value.RequestIDValue = result["result"][0]["RefNo"]
        .split(",")
        .map((i) => Number(i));
      RequestId = result["result"][0]["RefNo"];
    }

    async function IsShowPOByPRId() {
      debugger;
      loading.value = true;
      IsPOObj.value.IsPOUpdate = 1;
      console.log(POHiddenItemTable.value);
      items.value = POHiddenItemTable.value;

      POItemTable.value = POHiddenItemTable.value;
      LPOItemTable.value = POHiddenItemTable.value
        .filter((x) => x.POSupplierId !== 0 && x.POIsDraft != 1)
        .map((item) => {
          item.BrandLPO = item.Brand;
          item.ModelNumberLPO = item.ModelNumber;
          item.SizeLPO = item.Size;
          return item;
        });

      StoreDropdown.value.StoreId = POHiddenItemTable.value[0]["ToStore"];
      StoreDropdown.value.StoreBrMapId =
        POHiddenItemTable.value[0]["ToStoreBrMapId"];

      ///
      POItemTable.value.forEach((item) => {
        filtercateObj.value.push({
          ItemCategory1: item.ItemCategory1,
          CategoryId: item.CategoryId,
        });
        LoadFilterCategory(filtercateObj.value);
      });
      ///

      await SupplierInformation();
      loading.value = false;
    }

    //Load Items by StockWoTrans Id
    async function IsShowByStockTransIdPO(StockTransTMId) {
      debugger;
      loading.value = true;

      let result: any;

      result = await WithoutStockService.GetByStockWOTransByRefId(
        StockTransTMId
      );
      debugger;
      if (result["result"].length > 0) {
        result["result"] = result["result"].map((item) => {
          item.UnitRate = Number(item.UnitRate).toFixed(2);
          item.Rate = Number(item.Rate).toFixed(2);

          item.Discount = "0.00";
          item.Discountamount = "0.00";

          item.Amount = Number(
            Number(item.Rate) +
            Number(item.SGSTTaxAmount) +
            Number(item.CGSTTaxAmount) +
            Number(item.IGSTTaxAmount)
          ).toFixed(2);

          item.ItemBrandoption = BrandDropdownPO.value.ItemBrandoption;
          item.ItemModelNumberoption =
            ModelNumberDropdownPO.value.ItemModelNumberoption;
          item.ItemSizeoption = SizeDropdownPO.value.ItemSizeoption;
          return item;
        });

        POCalcDetails.value.TotalAmount = 0.0;
        for (let i = 0; i < result["result"].length; i++) {
          POCalcDetails.value.TotalAmount += parseFloat(
            result["result"][i]["Amount"]
          );
        }
        ObjVal.value.StoreBrMapId = result["result"][0].StoreBrMapId;
        ObjVal.value.FromStoreBrMapId = result["result"][0].FromStoreBrMapId;
        ObjVal.value.ToStoreBrMapId = result["result"][0].ToStoreBrMapId;
        ObjVal.value.FromStoreBranchId = result["result"][0].FromStoreBranchId;
        ObjVal.value.ToStoreBranchId = result["result"][0].ToStoreBranchId;

        POHiddenItemTable.value = result["result"].map((item) => {
          if (item.DocType == 18) {
            item.StockWOTransId = 0;
          } else {
          }
          return item;
        });

        console.log("initial PO table Items", POHiddenItemTable.value);

        await IsShowPOByPRId();

        IsPOObj.value.LPOTabHideAndShow = true;
      } else {
        alert("Something went wrong");
      }
      loading.value = false;
    }

    //Item Edit
    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      displayClass.value = "show";
    }

    //Item Delete for Item Table
    async function IsItemDelete(data) {
      debugger;
      let msg = null;
      if (ItemTable.value.length > 1) {
        if (data["StockDetailsId"]) {
          const result = await WithoutStockService.deleteStockWoDetails(
            data["StockDetailsId"]
          );
          msg = result["ErrorInfo"].ErrorCode;
        }
        if (msg == null) {
          items.value = items.value.filter(
            (item) =>
              item["ItemId"] != data.ItemId ||
              (data.ModelNumber !== undefined &&
                item["ModelNumber"] !== data.ModelNumber) ||
              (data.Size !== undefined && item["Size"] !== data.Size) ||
              (data.Brand !== undefined && item["Brand"] !== data.Brand)
          );

          ItemTable.value = ItemTable.value.filter(
            (item) =>
              item["ItemId"] != data.ItemId ||
              (data.ModelNumber !== undefined &&
                item["ModelNumber"] !== data.ModelNumber) ||
              (data.Size !== undefined && item["Size"] !== data.Size) ||
              (data.Brand !== undefined && item["Brand"] !== data.Brand)
          );

          toast.add({
            severity: "info",
            summary: "Item Removed",
            detail: "",
            life: 3000,
          });
          return;
        }
      } else {
        toast.add({
          severity: "warn",
          summary: "Cannot able to delete the last item",
          detail: "",
          life: 3000,
        });
        return;
      }
    }

    //Item Delete for Item Table
    async function IsPOItemDelete(data) {
      debugger;
      let msg = null;
      if (POItemTable.value.length > 1) {
        if (data["StockDetailsId"]) {
          const result = await WithoutStockService.deleteStockWoDetails(
            data["StockDetailsId"]
          );
          msg = result["ErrorInfo"].ErrorCode;
        }

        if (msg == null) {
          if (data["StockDetailsId"]) {
            items.value = items.value.filter(
              (item) => item["StockDetailsId"] != data.StockDetailsId
            );

            POItemTable.value = POItemTable.value.filter(
              (item) => item["StockDetailsId"] != data.StockDetailsId
            );
          } else {
            items.value = items.value.filter((item) => {
              return !(
                item["ItemId"] === data.ItemId &&
                item["Brand"] === data.Brand &&
                item["ModelNumber"] === data.ModelNumber &&
                item["Size"] === data.Size
              );
            });

            POItemTable.value = POItemTable.value.filter((item) => {
              return !(
                item["ItemId"] === data.ItemId &&
                item["Brand"] === data.Brand &&
                item["ModelNumber"] === data.ModelNumber &&
                item["Size"] === data.Size
              );
            });
          }

          toast.add({
            severity: "info",
            summary: "Item Removed",
            detail: "",
            life: 3000,
          });
          return;
        }
      } else {
        toast.add({
          severity: "warn",
          summary: "Cannot able to delete the last item",
          detail: "",
          life: 3000,
        });
        return;
      }
    }

    function TotalGrossCalc(value1) {
      debugger;
      grossvalues.value.grossamount = value1.grossamount;
      grossvalues.value.totalqty = value1.totalqty;
      grossvalues.value.taxamount = value1.taxamount;
      grossvalues.value.totaldiscountamount = value1.totaldiscountamount;
      grossvalues.value.othercharges = value1.totalothercharges;
      grossvalues.value.transportcharges = value1.totaltransportcharges;
      grossvalues.value.servicecharges = value1.totalservicecharges;
      grossvalues.value.netamount = value1.netamount;
    }

    function IsSubmit(SValue) {
      debugger;
      if (param == "PO" && SValue == "P") {
        IsCreatePO();
      } else {
        console.log(SValue);
      }
    }

    function SaveDraft(Value) {
      debugger;
      IsPOObj.value.SaveAsDraft = 1;
      if (Value == "PO") {
        IsCreatePO();
      } else {
        console.log(Value);
      }
    }

    // Create PO
    async function IsCreatePO() {
      debugger;
      let result: any = "";
      let message;
      let id = 0;
      ConvertToPOSaveloader.value = true;
      let arraylength = POItemTable.value.length;
      let QuantityValues: any = [];
      for (let i = 0; i < POItemTable.value.length; i++) {
        let qty = POItemTable.value[i].ItemQuantity;
        QuantityValues.push(POItemTable.value[i]["ItemQuantity"]);
      }
      // Filtering out non-numeric values and converting them to numbers
      let numericValues: number[] = QuantityValues.filter(
        (value) => typeof value === "number" || !isNaN(Number(value))
      ).map((value) => Number(value));

      // Calculating the sum of the numeric values
      let SumValues: number = numericValues.reduce(
        (acc, value) => acc + value,
        0
      );
      console.log(SumValues);
      if (POItemTable.value.length == 0) {
        ConvertToPOSaveloader.value = false;

        toast.add({
          severity: "warn",
          summary: "Add the Items",
          detail: "",
          life: 3000,
        });
        return;
      } else if (SumValues > 0) {
        let supvalue = POItemTable.value["SupplierId"];
        let suppliers: any = [];
        for (let i = 0; i < POItemTable.value.length; i++) {
          let supplier = POItemTable.value[i].SupplierId;
          if (POItemTable.value[i]["SupplierId"] != 0) {
            suppliers.push(POItemTable.value[i]["SupplierId"]);
          }
        }
        let uniqueSuppliers = suppliers.filter((supplier, index) => {
          return suppliers.indexOf(supplier) === index;
        });
        console.log(uniqueSuppliers);
        let filteredSupplierIds: any = uniqueSuppliers;
        const filteredItems = POItemTable.value.filter((item) => {
          return (
            item.hasOwnProperty("SupplierId") &&
            filteredSupplierIds.includes(item.SupplierId)
          );
        });
        console.log("filteredItems", filteredItems);
        const groupedItems = filteredItems.reduce(
          (accumulator, currentValue) => {
            const SupplierId = currentValue.SupplierId;
            if (!accumulator[SupplierId]) {
              accumulator[SupplierId] = [];
            }
            accumulator[SupplierId].push(currentValue);
            return accumulator;
          },
          {}
        );
        console.log(groupedItems);
        for (const key in groupedItems) {
          const currentArray = groupedItems[key];

          // Group data within SupplierId based on IsServiceLevel
          const isServiceLevelGroups = currentArray.reduce((acc, item) => {
            if (!acc[item.IsServiceLevel]) {
              acc[item.IsServiceLevel] = [];
            }
            acc[item.IsServiceLevel].push(item);
            return acc;
          }, {} as Record<number, any[]>);

          // Iterate through each IsServiceLevel group within a SupplierId
          for (const isServiceLevel in isServiceLevelGroups) {
            const groupedData = isServiceLevelGroups[isServiceLevel];

            ObjVal.value.Id = groupedData[0]["StockWOTransId"];
            ObjVal.value.DocType = "5";
            ObjVal.value.RefId = QueryStringValue3["StockWoTransTMId"];
            ObjVal.value.RefNo = QueryStringValue3["DocNo"];
            ObjVal.value.StoreId = StoreID;
            ObjVal.value.FromStore = StoreID;
            ObjVal.value.ToStore = StoreDropdown.value.StoreId;
            ObjVal.value.Amount = POCalcDetails.value.TotalAmount;
            ObjVal.value.SupplierId = groupedData[0]["SupplierId"];
            ObjVal.value.PaymentTermsId = 0;
            ObjVal.value.DeliveryTermsId = 0;
            ObjVal.value.IsDraft = 1;
            ObjVal.value.CreatedAt = moment().format(
              "YYYY-MM-DDTHH:mm:ss.SSSZ"
            );
            ObjVal.value.ModifiedAt = moment().format(
              "YYYY-MM-DDTHH:mm:ss.SSSZ"
            );
            ObjVal.value.BranchId = QueryStringValue3["BranchId"];
            ObjVal.value.HospitalId = HospitalId;
            ObjVal.value.ModifiedBy = UserId;
            ObjVal.value.CreatedBy = UserId;

            if (groupedData[0]["IsServiceLevel"] == 0) {
              ObjVal.value.EntityId = 3077;
              ObjVal.value.EntityOperationId = 3077001;
            } else if (groupedData[0]["IsServiceLevel"] == 1) {
              ObjVal.value.EntityId = 3078;
              ObjVal.value.EntityOperationId = 3078001;
            } else if (groupedData[0]["IsServiceLevel"] == 3) {
              ObjVal.value.EntityId = 3079;
              ObjVal.value.EntityOperationId = 3079001;
            } else if (groupedData[0]["IsServiceLevel"] == 4) {
              ObjVal.value.EntityId = 3129;
              ObjVal.value.EntityOperationId = 3129001;
            } else if (groupedData[0]["IsServiceLevel"] == 5) {
              ObjVal.value.EntityId = 3131;
              ObjVal.value.EntityOperationId = 3131001;
            }

            ObjVal.value.DeptRoleId = rolesData.DeptRoleMapId;
            ObjVal.value.IsServiceLevel = groupedData[0]["IsServiceLevel"]; // Set IsServiceLevel

            if (ObjVal.value.Id === 0) {
              result = await WithoutStockService.createStockWOTM(ObjVal.value);
              id = result["result"];
            } else {
              result = await WithoutStockService.updateStockWOTM(ObjVal.value);
              id = groupedData[0]["StockWOTransId"];
            }

            message = result["ErrorInfo"].ErrorCode;
            let POarr: any = [];
            let PRDetailsarr: any = [];

            if (message == null) {
              debugger;
              for (let i = 0; i < groupedData.length; i++) {
                if (groupedData[i]["ItemQuantity"] > 0) {
                  let obj = {};
                  let DetailsObj = {};

                  if (groupedData[i]["DocType"] == 18) {
                    PRstockDetailsIds.push(groupedData[i]["StockDetailsId"]);
                    groupedData[i]["StockDetailsId"] = 0;
                  }

                  obj["Id"] = groupedData[i]["StockDetailsId"];
                  obj["ItemId"] = groupedData[i]["ItemId"];
                  obj["Qty"] = groupedData[i]["ItemQuantity"];
                  obj["RefId"] = id;
                  obj["PackSizeId"] = groupedData[i]["PackSizeId"];
                  obj["UOM"] = groupedData[i]["UOM"];
                  obj["HSNId"] = groupedData[i]["HSNId"];
                  obj["UnitRate"] = groupedData[i]["UnitRate"];
                  obj["Rate"] = groupedData[i]["Rate"];
                  obj["DiscountPer"] = groupedData[i]["Discount"];
                  obj["DiscountAmount"] = groupedData[i]["Discountamount"];
                  obj["PurchaseTax"] = groupedData[i]["PurchasePercentage"];
                  obj["PurchaseTaxAmount"] =
                    groupedData[i]["Purchasetaxamount"];
                  obj["SGSTTax"] = groupedData[i]["SGSTTax"];
                  obj["SGSTTaxAmount"] = groupedData[i]["SGSTTaxAmount"];
                  obj["CGSTTax"] = groupedData[i]["CGSTTax"];
                  obj["CGSTTaxAmount"] = groupedData[i]["CGSTTaxAmount"];
                  obj["IGSTTax"] = groupedData[i]["IGSTTax"];
                  obj["IGSTTaxAmount"] = groupedData[i]["IGSTTaxAmount"];
                  obj["Amount"] = groupedData[i]["Amount"];
                  obj["CreatedAt"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  );
                  obj["ModifiedAt"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  );
                  obj["CreatedBy"] = UserId;
                  obj["ModifiedBy"] = UserId;
                  obj["Brand"] = groupedData[i]["Brand"] ?? 0;
                  obj["ModelNumber"] = groupedData[i]["ModelNumber"] ?? 0;
                  obj["Size"] = groupedData[i]["Size"] ?? 0;
                  obj["Status"] = 0;

                  POarr[i] = obj;
                  ItemRemove.value.push(obj);
                }
              }

              let result = await WithoutStockService.createStockWODetails(
                POarr
              );
              if (PRstockDetailsIds.length > 0) {
                PRstockDetailsIds.forEach((stockDetailsId) => {
                  PRDetailsarr.push({
                    Id: stockDetailsId,
                    Status: 1, // Setting status
                  });
                });

                if (PRDetailsarr.length > 0) {
                  await WithoutStockService.UpdateStatusStockWODetailsTD(
                    PRDetailsarr
                  );
                }
              }
              message = result["ErrorInfo"].ErrorCode;
            } else {
              ConvertToPOSaveloader.value = false;
              alert("Something went wrong");
              return;
            }
            console.log();
          }
        }

        // for (const key in groupedItems) {
        //   const currentArray = groupedItems[key];
        //   ObjVal.value.Id = currentArray[0]["StockWOTransId"];
        //   ObjVal.value.DocType = "5";
        //   ObjVal.value.RefId = QueryStringValue3["StockWoTransTMId"];
        //   ObjVal.value.RefNo = QueryStringValue3["DocNo"];
        //   ObjVal.value.StoreId = StoreID;
        //   ObjVal.value.FromStore = StoreID;
        //   ObjVal.value.ToStore = StoreDropdown.value.StoreId;
        //   // ObjVal.value.Amount = grossvalues.value.grossamount;
        //   ObjVal.value.Amount = POCalcDetails.value.TotalAmount;

        //   ObjVal.value.SupplierId = currentArray[0]["SupplierId"];
        //   ObjVal.value.PaymentTermsId = 0;
        //   ObjVal.value.DeliveryTermsId = 0;
        //   ObjVal.value.IsDraft = 1;
        //   ObjVal.value.CreatedAt = moment().format(
        //     "YYYY-MM-DDTHH:mm:ss.SSSZ"
        //   );
        //   ObjVal.value.ModifiedAt = moment().format(
        //     "YYYY-MM-DDTHH:mm:ss.SSSZ"
        //   );
        //   ObjVal.value.BranchId = QueryStringValue3["BranchId"];
        //   ObjVal.value.HospitalId = HospitalId;
        //   ObjVal.value.ModifiedBy = UserId;
        //   ObjVal.value.CreatedBy = UserId;
        //   ObjVal.value.EntityId = 334;
        //   ObjVal.value.EntityOperationId = 1035;
        //   ObjVal.value.DeptRoleId = rolesData.DeptRoleMapId;
        //   ObjVal.value.IsServiceLevel = 0;

        //   if (ObjVal.value.Id === 0) {
        //     result = await WithoutStockService.createStockWOTM(ObjVal.value);
        //     id = result["result"];
        //   } else {
        //     result = await WithoutStockService.updateStockWOTM(ObjVal.value);
        //     id = currentArray[0]["StockWOTransId"];
        //   }
        //   message = result["ErrorInfo"].ErrorCode;
        //   let POarr: any = [];
        //   let PRDetailsarr: any = [];
        //   if (message == null) {
        //     debugger;
        //     for (let i = 0; i < currentArray.length; i++) {
        //       if (currentArray[i]["ItemQuantity"] > 0) {
        //         let obj = {};
        //         let DetailsObj = {};

        //         if (currentArray[i]["DocType"] == 18) {
        //           PRstockDetailsIds.push(currentArray[i]["StockDetailsId"]);
        //           currentArray[i]["StockDetailsId"] = 0;
        //         }

        //         (obj["Id"] = currentArray[i]["StockDetailsId"]),
        //           (obj["ItemId"] = currentArray[i]["ItemId"]),
        //           (obj["Qty"] = currentArray[i]["ItemQuantity"]),
        //           (obj["RefId"] = id),
        //           (obj["PackSizeId"] = currentArray[i]["PackSizeId"]),
        //           (obj["UOM"] = currentArray[i]["UOM"]),
        //           (obj["HSNId"] = currentArray[i]["HSNId"]),
        //           (obj["UnitRate"] = currentArray[i]["UnitRate"]),
        //           (obj["Rate"] = currentArray[i]["Rate"]),
        //           (obj["DiscountPer"] = currentArray[i]["Discount"]),
        //           (obj["DiscountAmount"] = currentArray[i]["Discountamount"]),
        //           (obj["PurchaseTax"] = currentArray[i]["PurchasePercentage"]),
        //           (obj["PurchaseTaxAmount"] = currentArray[i]["Purchasetaxamount"]),
        //           (obj["SGSTTax"] = currentArray[i]["SGSTTax"]),
        //           (obj["SGSTTaxAmount"] = currentArray[i]["SGSTTaxAmount"]),
        //           (obj["CGSTTax"] = currentArray[i]["CGSTTax"]),
        //           (obj["CGSTTaxAmount"] = currentArray[i]["CGSTTaxAmount"]),
        //           (obj["IGSTTax"] = currentArray[i]["IGSTTax"]),
        //           (obj["IGSTTaxAmount"] = currentArray[i]["IGSTTaxAmount"]),
        //           (obj["Amount"] = currentArray[i]["Amount"]),
        //           (obj["CreatedAt"] = moment().format(
        //             "YYYY-MM-DDTHH:mm:ss.SSSZ"
        //           )),
        //           (obj["ModifiedAt"] = moment().format(
        //             "YYYY-MM-DDTHH:mm:ss.SSSZ"
        //           )),
        //           (obj["CreatedBy"] = UserId),
        //           (obj["ModifiedBy"] = UserId),
        //           (obj["Brand"] =
        //             currentArray[i]["Brand"] == null ||
        //               currentArray[i]["Brand"] == undefined ?
        //               0 :
        //               currentArray[i]["Brand"]),
        //           (obj["ModelNumber"] =
        //             currentArray[i]["ModelNumber"] == null ||
        //               currentArray[i]["ModelNumber"] == undefined ?
        //               0 :
        //               currentArray[i]["ModelNumber"]),
        //           (obj["Size"] =
        //             currentArray[i]["Size"] == null ||
        //               currentArray[i]["Size"] == undefined ?
        //               0 :
        //               currentArray[i]["Size"]),

        //           (obj["Status"] = 0),

        //           (POarr[i] = obj);
        //         ItemRemove.value.push(obj);
        //       }
        //     }
        //     let result = await WithoutStockService.createStockWODetails(
        //       POarr
        //     );
        //     if (PRstockDetailsIds.length > 0) {
        //       PRstockDetailsIds.forEach((stockDetailsId) => {
        //         PRDetailsarr.push({
        //           Id: stockDetailsId,
        //           Status: 1, // Assuming you want to set the status to 0
        //         });
        //       });

        //       if (PRDetailsarr.length > 0) {
        //         let response = await WithoutStockService.UpdateStatusStockWODetailsTD(
        //           PRDetailsarr,
        //         );
        //       }
        //     }
        //     message = result["ErrorInfo"].ErrorCode;
        //   } else {
        //     ConvertToPOSaveloader.value = false;

        //     alert("Somthing went wrong");
        //     return;
        //   }
        //   console.log();
        // }

        if (message == null) {
          if (IsPOObj.value.SaveAsDraft == 1) {
            alert(
              "your data has been saved for future editing. You can continue to work on your submission later."
            );
            setupHistoryManagement(router, 2);
          } else {
            ConvertToPOSaveloader.value = false;
            router.push({
              path: "/PRtoPo",
              query: {
                PRId: StockWoTransTMId,
                BranchId: QueryStringValue3["BranchId"],
              },
            });
          }
        } else {
          ConvertToPOSaveloader.value = false;
          alert("Somthing went wrong");
          return;
        }
      } else {
        ConvertToPOSaveloader.value = false;
        toast.add({
          severity: "info",
          summary: "Add the quantity for the Items",
          detail: "",
          life: 3000,
        });
        return;
      }
    }

    // Update PO against PR
    let PRstockDetailsIds: any = [];

    function LPOselectedProductFunction(value) {
      debugger;
      LPOselectedProduct.value = value;
    }

    let warningmsgcontent = ref({
      warningcontent: "",
      TitleContent: "",
      SubmitButtonName: "",
    });

    const confirmval = ref();

    function ClosewariningPopup() {
      debugger;
      wariningPopup.value = false;
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
    }

    function POclosetrigger() {
      POsuccesspop.value = false;
      setupHistoryManagement(router, 2);
    }

    const onDropdownBlur = () => {
      console.log("js");
      //requestdropdown.value = false;
    };

    function RowClick(data) {
      debugger;
      // LPOselectedProduct.value.push(data.data);
    }

    const scrollContainer: any = ref(null);

    const scrollForward = () => {
      if (scrollContainer.value) {
        scrollContainer.value.scrollLeft += 50;
      }
    };

    const scrollBackward = () => {
      if (scrollContainer.value) {
        scrollContainer.value.scrollLeft -= 50;
      }
    };

    return {
      scrollContainer,
      scrollForward,
      scrollBackward,
      StoreID,
      showitemfield,
      ShowItems,
      globalFilterFields,
      filters,
      items,
      headers,
      loading,
      paramValue,
      requestid,
      handleValues,
      AddItems,
      List,
      RequestIDOnChange,
      LoadRequestID,
      ObjVal,
      IsSubmit,
      showFields,
      IsItemEdit,
      IsItemDelete,
      dataItems,
      commonItemProps,
      IsShowByStockTransId,
      closetrigger,
      successpop,
      updatepop,
      ReOrderData,
      ReOrderheaders,
      selectedProduct,
      ReadyFunction,
      wariningPopup,
      ClosewariningPopup,
      warningmsgcontent,
      confirmval,
      TotalGrossCalc,
      displayClass,
      clases,
      requestdropdown,
      requestValue,
      requestidValue,
      onDropdownBlur,
      requestdata,
      StoreDropdown,
      StoreOnChange,
      ItemTable,
      ObjPRInfo,
      param,
      POheaders,
      POItemTable,
      IsPOItemDelete,
      LPOheaders,
      LPOItemTable,
      POsuccesspop,
      POclosetrigger,
      BrandDropdownPO,
      ModelNumberDropdownPO,
      SizeDropdownPO,
      BrandDropdownLPO,
      ModelNumberDropdownLPO,
      SizeDropdownLPO,
      LPOselectedProduct,
      LPOselectedProductFunction,
      RowClick,
      StoreDropdownDisable,
      filterBrand,
      filterModelNumber,
      filterSize,

      //
      FilterCategoryDropdown,
      FilterCategoryOnChange,
      FilterSupplierDropdown,
      ItemSearchFunction,
      SearchValue,
      POselectedProduct,
      POselectedProductFunction,
      POselectedProductCount,
      SupplierAdd,
      SupplierAddCancel,
      SupplierInfo,
      SaveDraft,
      POHiddenItemArray,
      IsPOObj,
      AddLPOItems,
      POCalcDetails,
      fileviewer,
      uploadedTableList,
      ConvertToPOSaveloader,
    };
  },
  created() { },
});
</script>
<style lang="scss">
.requestlabel {
  display: block !important;
}

.prtopo .p-dropdown.p-dropdown-clearable .p-dropdown-label {
  padding-right: 0.5rem !important;
}

.proceedbtn .p-button {
  background-color: #3096ff;
  padding: 5px 15px;
  border: 1px solid #3096ff;

  .p-button-label {
    font-weight: 500;
  }
}

.proceedbtn .p-button:hover {
  background-color: #3096ff !important;
  padding: 5px 15px;
  border: 1px solid #3096ff;
}

.prtable .p-tabview .p-tabview-nav {
  width: max-content !important;
}
</style>
<style lang="scss" scoped>
.actioncardbg {
  border: 1px solid #e1e1e1;
  align-items: center;
  padding: 10px;
  background-color: #f9fbfc;
  border-radius: 5px;
  margin: 15px 0;

  .selectedcount {
    font-weight: 500;
  }
}

.supplierlistbg {
  background-color: #000000;
  border: 1px solid #303132;
  display: flex;
  align-items: center;

  .supplieractionbtnsbg {
    border-right: 1px solid #e1e1e1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 10px 5px;
    width: 100px;

    .pi {
      font-size: 25px;
    }
  }

  .supplierdetails {
    width: 850px;
    overflow: auto;
    display: flex;
    align-items: center;

    .suppliercardsbg {
      border-right: 1px solid #e1e1e1;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      color: #ffffff;
      width: max-content;
      white-space: nowrap;
    }
  }

  .proceedbtn {
    //float: right;
    white-space: nowrap;
  }
}

.savedraftbtn {
  border: 1px solid #999999;
  padding: 5px 15px;
  width: max-content;
  border-radius: 5px;
  background-color: #ffffff;

  p {
    color: #999999;
  }
}

.scroll-container {
  overflow-x: auto;
  white-space: nowrap;
  border: 1px solid #ccc;
}

.w-90 {
  width: 90%;
}

.card-search .pi-search {
  position: absolute !important;
  top: 0.75rem;
  left: 0.55rem;
  color: #e1e1e1;
}
</style>
